import React from 'react'
import { Row, Col, Form } from 'antd'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import logo from '../static/images/New_logo.jpg'
import useDownloadPdf from '../hooks/DownloadPdf'
import apiRequest from '../hooks/ApiRequest'

function roundvalue(value) {
  if (value > 0) {
    return parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
  }
  return 0
}

class DebitNote extends React.Component {
  constructor(props) {
    super(props)
    this.downloadPdf = useDownloadPdf().generatePdf
    this.state = {
      policyId: localStorage.getItem('PolicyID'),
      quotationId: '',
      policyEndDate: '',
      PolicyStartDate: '',
      clientname: '',
      RefundableAmount: 0.0,
      policyRiskCover: '',
      policyRiskCoverItems: '',
      totalSumInsured: 0.0,
      transactionDate: '',
      currency: '',
      productname: '',
      client_mobile: '',
      client_id_number: '',
      client_address: '',
      client_age: '',
      policyNumber: '',
      businessaddress: '',
      brokerFirstName: '',
      brokerLastName: '',
      brokerEmail: '',
      brokerContact: '',
      policyProRataPremium: 0.0,
      totalPaid: 0.0,
      debitNoteAmount: 0.0,
      columns: [
        {
          key: 'riskitem',
          title: 'Risk Item Details',
          dataIndex: 'riskitemname',
        },
        {
          key: 'address',
          title: 'Risk Address',
          dataIndex: 'address',
        },
        {
          key: 'suminsured',
          title: 'Sum Insured',
          dataIndex: 'suminsured',
        },
        {
          key: 'Proratapremium',
          title: 'Premium',
          dataIndex: 'annualpremium',
        },
      ],
      data: [],
      status: '',
    }
    this.calculateRefundableAmount = this.calculateRefundableAmount.bind(this)
    this.findDayDifference = this.findDayDifference.bind(this)
  }

  componentDidMount() {
    apiRequest(
      process.env.REACT_APP_BASE_URL +
      '/Policy/GetPolicybyid/' +
      this.state.policyId,
      'GET'
    ).then(response => {
      debugger;
      let policydetail = response.data.policydetail

      // Total Paid Amount from payments
      let totalPaid = 0;

      // 🔍 Some APIs send payment in "paymentdetails", some in "payment_detail"
      if (response.data.payment_detail && response.data.payment_detail.length > 0) {
        totalPaid = response.data.payment_detail.reduce(
          (sum, p) => sum + (p.payment_amount || 0),
          0
        );
      } else if (response.data.payment_detail) {
        // Single payment object
        totalPaid = response.data.payment_detail.payment_amount || 0;
      }

      debugger;

      // Premium based on product
      const totalPremium = policydetail.grandtotaltermpremium || 0;

      //  Debit Note Amount
      const debitNoteAmount = roundvalue(totalPremium - totalPaid)
      debugger;

      this.setState({
        clientname:
          response.data.customerdetail.clientfirstname +
          ' ' +
          response.data.customerdetail.clientsurname,
        client_mobile: response.data.customerdetail.clientcontactnumber,
        client_address: response.data.customerdetail.clientaddress1,
        client_age: response.data.customerdetail.clientage,
        client_id_number: response.data.customerdetail.nationalid,
        data: policydetail.riskitemdetails,
        policyNumber: policydetail.policynumber,
        PolicyStartDate: policydetail.policystartdate,
        policyEndDate: policydetail.policyexpirytdate,
        policyRiskCover: policydetail.policyriskcover,
        currency: policydetail.currency,
        productname: policydetail.productname,
        clientEmail: response.data.customerdetail.clientemailaddress,
        stampDuty:
          policydetail.productid === 5 || policydetail.productid === 3
            ? policydetail.stampdutyannualpremium
            : 0.0,
        brokerFirstName: response?.data?.fetchBrokerDTO?.firstName,
        brokerLastName: response?.data?.fetchBrokerDTO?.lastName,
        brokerEmail: response?.data?.fetchBrokerDTO?.email,
        brokerContact: response?.data?.fetchBrokerDTO?.mobileNumber,
        transactionDate: policydetail.createddate.toString().slice(0, 10),
        policyProRataPremium: totalPremium,
        totalPaid,
        debitNoteAmount,
      })

      debugger;
      //  Total Sum Insured
      let totalSum = policydetail.riskitemdetails.reduce(
        (sum, r) => sum + (r.suminsured || 0),
        0
      )
      this.setState({ totalSumInsured: roundvalue(totalSum) })
    })

    apiRequest(
      process.env.REACT_APP_BASE_URL_ADMIN +
      '/Product/GetGloabalList/' +
      localStorage.getItem('productId'),
      'GET'
    ).then(data => {
      if (data.success) {
        this.setState({
          allData: data.data.result.mastersetting[0],
          businessaddress: data.data.result.mastersetting[0].businessaddress,
        })
      }
    })
  }

  findDayDifference(date1, date2) {
    return Math.floor(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24))
  }

  componentWillUnmount() {
    localStorage.removeItem('PolicyID')
    debugger;
  }

  calculateRefundableAmount(date, datestring) {
    var Noofdays = this.findDayDifference(
      new Date(this.state.PolicyEndDate),
      new Date(datestring)
    )
    Noofdays = Noofdays + 1

    this.setState({
      RefundableAmount: roundvalue(
        this.state.PolicyAnnualPremium * (Noofdays / 365)
      ),
    })
  }

  render() {
    return (
      <div
        className="container-box"
        style={{ margin: '15px auto 0', width: '100%', maxWidth: '100%' }}
      >
        <div
          id="divToPrint"
          className="white-box-bg"
          style={{ padding: '30px 15px 50px', width: '100%', margin: 'auto' }}
        >
          <div
            style={{
              padding: '15px 0',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
            }}
          >
            <img src={logo} className="logo-img" style={{ width: '250px' }} />
            <h3
              style={{
                marginLeft: '125px',
                textTransform: 'uppercase',
                fontWeight: '800',
                fontSize: '22px',
              }}
            >
              Debit note
            </h3>
          </div>

          <div style={{ padding: '10px' }}>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                  backgroundColor: '#7bdaff',
                }}
              >
                Bill To
              </h4>
              <div>
                <ul
                  style={{
                    padding: '5px 20px 20px 0',
                    fontSize: '14px',
                    color: '#000',
                    fontWeight: '500',
                    margin: '0',
                    listStyle: 'none',
                  }}
                >
                  <Row gutter={[16, 16]}>
                    <Col xs={12} sm={8} md={8} lg={12}>
                      <li>
                        {this.state.clientname.includes('undefined')
                          ? this.state.clientname.slice(9)
                          : this.state.clientname}
                      </li>
                      <li>{this.state.client_address}</li>
                      <li>{this.state.client_mobile}</li>
                      <li>{this.state.clientEmail}</li>
                    </Col>
                    <Col xs={12} sm={8} md={8} lg={12}>
                      <div style={{ textAlign: 'start' }}>
                        <ul
                          style={{
                            padding: '5px 0px 20px 0',
                            fontSize: '14px',
                            color: '#000',
                            fontWeight: '500',
                            margin: '0',
                            listStyle: 'none',
                          }}
                        >
                          <li>Created Date: {this.state.transactionDate}</li>
                          <li>Transaction Date: {this.state.transactionDate}</li>
                          <li>Policy No. : {this.state.policyNumber} </li>
                          <li>
                            Total Amount Due: {this.state.debitNoteAmount}{' '}
                          </li>
                          <li>Currency: {this.state.currency} </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </ul>
              </div>

              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                  backgroundColor: '#7bdaff',
                }}
              >
                Broker detail
              </h4>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '5px 20px 20px 0',
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}
                  >
                    <li>Name:</li>
                    <li>Email:</li>
                    <li>Contact:</li>
                  </ul>
                </div>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '5px 20px 20px 0',
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}
                  >
                    <li>
                      {this.state.brokerFirstName} {this.state.brokerLastName}
                    </li>
                    <li>{this.state.brokerEmail}</li>
                    <li>{this.state.brokerContact}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                  backgroundColor: '#7bdaff',
                }}
              >
                Premium and License Fees
              </h4>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '5px 20px 20px 0',
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}
                  >
                    {this.state.stampDuty > 0 && <li>Stamp Duty:</li>}
                    <li>Amount Due:</li>
                  </ul>
                </div>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '5px 20px 20px 0',
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}
                  >
                    {this.state.stampDuty > 0 && <li>{this.state.stampDuty}</li>}
                    <li>{this.state.debitNoteAmount}</li>
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '10px',
                }}
              >
                <p>
                  <b>Thank you for your business!!</b>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          className="pdf-btn-none"
          style={{ textAlign: 'right', marginBottom: '10px' }}
        >
          <button
            className="primary"
            style={{ width: '200px' }}
            onClick={() => this.downloadPdf('divToPrint', 'DebitNote.pdf')}
          >
            Download
          </button>
        </div>
      </div>
    )
  }
}

const WrappedDebitNote = Form.create({ name: 'Homeinsurance_list' })(DebitNote)

export default WrappedDebitNote
